var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkTank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 1.796,
    y1: 3.539,
    x2: 1.796,
    y2: 16.454
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 18.326,
    y1: 3.703,
    x2: 18.326,
    y2: 16.617
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "none",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 10.061,
    cy: 3.539,
    rx: 8.265,
    ry: 2.707
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M18.326,16.454c0,1.495-3.7,2.707-8.265,2.707s-8.265-1.212-8.265-2.707"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkTank);
export default __webpack_public_path__ + "static/media/dark-tank.14d4fe5c48ccf46e65208b5bbc1563c9.svg";
export { ForwardRef as ReactComponent };